import { useState } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';

export const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const subject = encodeURIComponent(`Consulta de ${formData.name} - Prestagro`);
    const body = encodeURIComponent(
      `Nombre: ${formData.name}\n` +
      `Email: ${formData.email}\n` +
      `Teléfono: ${formData.phone || 'No proporcionado'}\n\n` +
      `Mensaje:\n${formData.message}`
    );
    
    window.location.href = `mailto:prestagro.arg@gmail.com?subject=${subject}&body=${body}`;
  };

  return (
    <section
      id="contacto"
      className="py-16 md:py-24 bg-[#FBF5EA]"
      data-testid="contact-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Contact Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* Contact Info */}
          <div>
            <span className="inline-block text-sm font-bold uppercase tracking-[0.2em] text-[#AB6D4C] mb-4">
              Contacto
            </span>
            <h2 className="text-4xl md:text-5xl font-medium tracking-tight text-[#051914] mb-6">
              Hablemos
            </h2>
            <p className="text-lg leading-relaxed text-[#051914]/70 mb-10">
              ¿Tenés preguntas o querés una demo personalizada? Nuestro equipo está 
              listo para ayudarte. Escribinos o llamanos.
            </p>

            <div className="space-y-6">
              <div className="flex items-start gap-4" data-testid="contact-email">
                <div className="w-12 h-12 bg-[#EBE9BD] rounded-xl flex items-center justify-center flex-shrink-0">
                  <Mail size={24} className="text-[#051914]" />
                </div>
                <div>
                  <h4 className="font-medium text-[#051914] mb-1">Email</h4>
                  <p className="text-[#051914]/60">contacto@prestagro.com</p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-testid="contact-phone">
                <div className="w-12 h-12 bg-[#EBE9BD] rounded-xl flex items-center justify-center flex-shrink-0">
                  <Phone size={24} className="text-[#051914]" />
                </div>
                <div>
                  <h4 className="font-medium text-[#051914] mb-1">Teléfono</h4>
                  <p className="text-[#051914]/60">+54 11 5555-0000</p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-testid="contact-address">
                <div className="w-12 h-12 bg-[#EBE9BD] rounded-xl flex items-center justify-center flex-shrink-0">
                  <MapPin size={24} className="text-[#051914]" />
                </div>
                <div>
                  <h4 className="font-medium text-[#051914] mb-1">Dirección</h4>
                  <p className="text-[#051914]/60">
                    Av. del Libertador 1000<br />
                    Ciudad Autónoma de Buenos Aires<br />
                    Argentina
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-[#EBE9BD] rounded-3xl p-8 md:p-10">
            <h3 className="text-xl font-medium text-[#051914] mb-6">
              Envianos un mensaje
            </h3>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-[#051914] mb-2">
                  Nombre completo
                </label>
                <input
                  type="text"
                  id="name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full bg-[#FBF5EA] border-0 rounded-xl px-5 py-4 text-[#051914] placeholder-[#051914]/40 focus:outline-none focus:ring-2 focus:ring-[#A9CB68]"
                  placeholder="Juan Pérez"
                  required
                  data-testid="contact-name-input"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-[#051914] mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full bg-[#FBF5EA] border-0 rounded-xl px-5 py-4 text-[#051914] placeholder-[#051914]/40 focus:outline-none focus:ring-2 focus:ring-[#A9CB68]"
                    placeholder="juan@email.com"
                    required
                    data-testid="contact-email-input"
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-[#051914] mb-2">
                    Teléfono
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="w-full bg-[#FBF5EA] border-0 rounded-xl px-5 py-4 text-[#051914] placeholder-[#051914]/40 focus:outline-none focus:ring-2 focus:ring-[#A9CB68]"
                    placeholder="+54 11 1234-5678"
                    data-testid="contact-phone-input"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-[#051914] mb-2">
                  Mensaje
                </label>
                <textarea
                  id="message"
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  rows={4}
                  className="w-full bg-[#FBF5EA] border-0 rounded-xl px-5 py-4 text-[#051914] placeholder-[#051914]/40 focus:outline-none focus:ring-2 focus:ring-[#A9CB68] resize-none"
                  placeholder="¿En qué podemos ayudarte?"
                  required
                  data-testid="contact-message-input"
                />
              </div>

              <button
                type="submit"
                className="w-full bg-[#051914] text-[#FBF5EA] font-medium px-6 py-4 rounded-full hover:bg-[#013527] transition-all flex items-center justify-center gap-2"
                data-testid="contact-submit-btn"
              >
                Enviar mensaje
                <Send size={18} />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
